/* Clayit 2026, Laid Flat. The whole script budget: the phone menu, the reveal, and films that play
   only while they are on screen. No library, no smooth-scroll hijack, nothing on the first screen. */
(function () {
  'use strict';
  var d = document, de = d.documentElement;

  /* the phone menu */
  var b = d.querySelector('[data-menu-toggle]'), p = d.getElementById('lf-panel');
  if (b && p) {
    var set = function (open) {
      b.setAttribute('aria-expanded', open ? 'true' : 'false');
      p.hidden = !open;
      b.textContent = open ? 'Close' : 'Menu';
      de.classList.toggle('lf-open', open);
    };
    b.addEventListener('click', function () { set(b.getAttribute('aria-expanded') !== 'true'); });
    d.addEventListener('keydown', function (e) { if (e.key === 'Escape' && !p.hidden) { set(false); b.focus(); } });
    window.addEventListener('resize', function () { if (window.innerWidth > 899 && !p.hidden) set(false); });
  }

  var reduce = window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches;
  if (!('IntersectionObserver' in window)) return;

  /* the reveal: pieces from the third screen on are laid down as they arrive, once; the first two
     screens are always drawn whole, so a fast scroll never lands on an empty band */
  if (!reduce) {
    var sel = '.sheet .sh, .gal > figure, .gal > .words, .gal > .film, .sd-row, .sd-clients li, .sd-habit, .next .grid, .hero-row, .ct2-col';
    var vh = window.innerHeight, marked = [];
    d.querySelectorAll(sel).forEach(function (el) {
      if (el.getBoundingClientRect().top > vh * 1.9) { el.setAttribute('data-rv', ''); marked.push(el); }
    });
    if (marked.length) {
      de.classList.add('lf-js');
      var io = new IntersectionObserver(function (es) {
        es.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('in'); io.unobserve(e.target); } });
      }, { rootMargin: '0px 0px -8% 0px', threshold: 0.06 });
      marked.forEach(function (el) { io.observe(el); });
      /* anything jumped past (an anchor link, a restored scroll) is shown at once, never left hidden */
      var sweep = function () { marked.forEach(function (el) { if (!el.classList.contains('in') && el.getBoundingClientRect().bottom < window.innerHeight) el.classList.add('in'); }); };
      window.addEventListener('scroll', sweep, { passive: true });
      window.addEventListener('hashchange', sweep);
      window.addEventListener('beforeprint', function () { marked.forEach(function (el) { el.classList.add('in'); }); });
    }
  }

  /* films play while on screen and rest when not */
  var films = d.querySelectorAll('video[data-film]');
  if (films.length) {
    var fo = new IntersectionObserver(function (es) {
      es.forEach(function (e) {
        var v = e.target;
        if (e.isIntersecting && !reduce) { var q = v.play(); if (q && q.catch) q.catch(function () {}); }
        else v.pause();
      });
    }, { threshold: 0.2 });
    films.forEach(function (v) { fo.observe(v); });
  }
})();
